import { graphql } from '@teachino/shared-infrastructure';
import { planFragment } from './plan.fragment';

export const availablePlansQuery = graphql(
  `
    query AvailablePlans {
      userPlans {
        ...plan
      }
    }
  `,
  [planFragment],
);
